import {MobXHelper} from "common-import/helpers";
import api from "./CompanyInfo.API";

const { makePersit } = MobXHelper;

const PERSIST_STORE_ITEM = {
}

class Store {
  constructor() {

  }

  find = async (data) => {
    let res = await api.find(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  }
}

export default new Store();



// WEBPACK FOOTER //
// ./src/services/companyInfo/CompanyInfo.Store.js